// src/utils/fiscalCalculations.js

/**
 * Calcule les parts fiscales d'un individu
 * @param {Object} individual - L'individu
 * @returns {number} Le nombre de parts fiscales
 */
export function calculateFiscalParts(individual) {
  let parts = 1; // Base célibataire

  // Situation maritale
  const maritalStatus = individual.maritalStatus || individual.marital_status;
  if (['Marié', 'Pacsé'].includes(maritalStatus)) {
    parts = 2;
  }

  // Enfants
  const children = individual.childrenCount || individual.children_count || 0;
  if (children >= 1) parts += 0.5; // 1er enfant
  if (children >= 2) parts += 0.5; // 2ème enfant
  if (children >= 3) parts += (children - 2) * 1; // 3ème et suivants

  // Parent isolé (célibataire/divorcé/veuf avec enfants)
  const singleParent = individual.singleParent || individual.single_parent;
  if (singleParent && children > 0) {
    parts += 0.5;
  }

  return parts;
}

/**
 * Options de statut marital
 */
export const MARITAL_STATUS_OPTIONS = [
  { value: 'Célibataire', label: 'Célibataire', icon: '👤' },
  { value: 'Marié', label: 'Marié(e)', icon: '💍' },
  { value: 'Pacsé', label: 'Pacsé(e)', icon: '🤝' },
  { value: 'Divorcé', label: 'Divorcé(e)', icon: '💔' },
  { value: 'Veuf', label: 'Veuf/Veuve', icon: '🕯️' },
];

/**
 * Options de type d'emploi
 */
export const EMPLOYMENT_TYPE_OPTIONS = [
  { value: 'Salarié', label: 'Salarié', icon: '💼', description: 'CDI, CDD, fonctionnaire' },
  { value: 'Autoentrepreneur', label: 'Indépendant', icon: '🏪', description: 'Auto-entrepreneur, profession libérale' },
  { value: 'FranceTravail', label: 'Chômage', icon: '📋', description: 'France Travail, ARE' },
  { value: 'Retraité', label: 'Retraité', icon: '🏖️', description: 'Pension de retraite' },
  { value: 'SansEmploi', label: 'Autre', icon: '👤', description: 'Sans emploi, étudiant...' },
];
